export const ENABLE_NEW_ORDERS_PAGE =
  process.env.REACT_APP_ENABLE_NEW_ORDERS_PAGE === 'true';

export const VENDORS_WITH_SHIPPING_COST_VALIDATION =
  process.env.REACT_APP_SHIPPING_COST_VALIDATION_ALLOWED_USERS?.split(',').map(
    elm => atob(elm),
  ) || [];

export const enableShippingCostValidation = email =>
  VENDORS_WITH_SHIPPING_COST_VALIDATION.includes(email);

export const ENABLE_ORDER_CANCELLATION =
  process.env.REACT_APP_ENABLE_ORDER_CANCELLATION === 'true';
